import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import ClearButton from '../ClearButton';
import './index.scss';

const SearchIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
    </svg>
);

const SearchPill = forwardRef(function SearchPill({
    value,
    onChange,
    placeholder = '',
    ariaLabel,
    className = '',
    name = 'search',
    onClear,
    clearAriaLabel,
    ...rest
}, ref) {
    const showClear = typeof onClear === 'function' && typeof value === 'string' && value.length > 0;
    return (
        <label
            className={classNames('search-pill', className)}
            aria-label={ariaLabel || placeholder}
        >
            <span className="search-pill__icon">
                <SearchIcon />
            </span>
            <input
                ref={ref}
                type="search"
                name={name}
                className="search-pill__input"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                aria-label={ariaLabel || placeholder}
                autoComplete="off"
                {...rest}
            />
            {showClear ? (
                <ClearButton
                    className="search-pill__clear"
                    ariaLabel={clearAriaLabel || ariaLabel || placeholder || 'Clear'}
                    onClick={(event) => {
                        // Wrapping <label> would re-focus the input on click; stop the
                        // event so the click registers as a clear, not as input focus.
                        event.preventDefault();
                        event.stopPropagation();
                        onClear();
                    }}
                />
            ) : null}
        </label>
    );
});

SearchPill.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string,
    onClear: PropTypes.func,
    clearAriaLabel: PropTypes.string,
};

export default SearchPill;
